/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {CheckIcon} from '@heroicons/react/outline';

import Link from './Link';
import Button, {ButtonTypes} from './ButtonNew';
import {StarIcon} from './svg';
import {createURLWithParams, startsWithVowel, shouldHideCoaching} from '../util';
import {useAppContext} from '../hooks';

const BlogCoachCard = ({tag, trackerEvent, urlParams}) => {
  const {currentUser} = useAppContext();
  let url;
  if (tag.type === 'company') url = `/coaching?company=${tag.id}`;
  else if (tag.type === 'role') url = `/coaching?role=${tag.id}`;

  const link = createURLWithParams(url, urlParams);

  const handleClick = () => {
    trackerEvent?.();
  };

  return !shouldHideCoaching(currentUser) && (
    <div
      className="-mx-2 block cursor-pointer border border-gray-200 rounded-lg overflow-hidden"
      onClick={handleClick}
    >
      <div className="py-4 px-4">
        {url ? (
          <Link href={url}>
            <h3 className="text-lg font-semibold mb-1 leading-tight tracking-tight">
              {`Book time with ${startsWithVowel(tag.name) ? 'an' : 'a'} ${tag.name} coach`}
            </h3>
          </Link>
        ) : (
          <h3 className="text-lg font-semibold mb-1 leading-tight tracking-tight">
            {`Book time with ${startsWithVowel(tag.name) ? 'an' : 'a'} ${tag.name} coach`}
          </h3>
        )}

        <ul className="my-3 text-sm text-gray-500 font-regular space-y-1">
          <li className="flex items-center gap-1">
            <CheckIcon className="h-5 w-5 text-indigo-600" />
            Mock interviews
          </li>
          <li className="flex items-center gap-1">
            <CheckIcon className="h-5 w-5 text-indigo-600" />
            Career coaching
          </li>
          <li className="flex items-center gap-1">
            <CheckIcon className="h-5 w-5 text-indigo-600" />
            Resume review
          </li>
        </ul>
        <Button
          onClick={handleClick}
          href={link}
          target="_blank"
          buttonType={ButtonTypes.SECONDARY}
          className="w-full"
        >
          {'Browse coaches ->'}
        </Button>
      </div>
      <div className="flex items-center justify-center p-2 bg-gray-50 text-gray-900 font-medium text-xs">
        <StarIcon className="mr-1 h-5 w-5 text-yellow-400" />
        96% rating (5,400 reviews)
      </div>
    </div>
  );
};

export default BlogCoachCard;
